import Seo from "@components/seo";
import CtaArea from "@containers/cta/layout-04";
import FaqArea from "@containers/faq/layout-02";
import IntroArea from "@containers/intro/layout-01";
import WhatsNewArea from "@containers/whats-new/layout-01";
import Layout from "@layout";
import Footer from "@layout/footer/layout-01";
import Header from "@layout/header/layout-05";
import { Col, Container, Row } from "@ui/wrapper";
import { normalizedData } from "@utils";
import { ImageType } from "@utils/types";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import * as React from "react";
import {
    BannerArea,
    StyledBannerTextWrap,
    StyledTagline,
    StyledTitle,
} from "./style";

const ITSolutionTemplate = ({ location, data }) => {
    const globalContent = normalizedData(data?.allGeneral.nodes || []);
    const content = normalizedData(data?.itSolution?.content || []);
    const pageData = data.itSolution;

    return (
        <Layout location={location}>
            <Seo title={pageData?.title} />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                    socials: data.site.siteMetadata.socials,
                }}
            />
            <main className="site-wrapper-reveal">
                <BannerArea>
                    <Container>
                        <Row>
                            <Col>
                                <StyledBannerTextWrap>
                                    {pageData?.title && (
                                        <StyledTitle>
                                            {pageData.title}
                                        </StyledTitle>
                                    )}
                                    {pageData?.tagline && (
                                        <StyledTagline>
                                            {pageData.tagline}
                                        </StyledTagline>
                                    )}
                                </StyledBannerTextWrap>
                            </Col>
                        </Row>
                    </Container>
                </BannerArea>

                <FaqArea space={2} data={content["faq-section"]} />
                <WhatsNewArea space={2} data={content["whats-new-section"]} />
                <IntroArea data={content["intro-section"]} />
                <CtaArea data={content["cta-section"]} />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query ItSolutionDetailsQuery($slug: String!) {
        allGeneral {
            nodes {
                section
                ...HeaderTwo
            }
        }
        site {
            ...Site
        }
        itSolution(slug: { eq: $slug }) {
            title
            tagline
            banner_image {
                alt
                src {
                    childImageSharp {
                        gatsbyImageData(
                            width: 100
                            formats: WEBP
                            placeholder: TRACED_SVG
                            layout: FULL_WIDTH
                        )
                    }
                }
            }
            content {
                ...SolutionContent
            }
        }
    }
`;

ITSolutionTemplate.propTypes = {
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                socials: PropTypes.arrayOf(PropTypes.shape({})),
            }),
        }),
        itSolution: PropTypes.shape({
            banner_image: PropTypes.shape(ImageType),
            title: PropTypes.string,
            tagline: PropTypes.string,
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default ITSolutionTemplate;
